import { ChangeDetectorRef, Component, Inject, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { trimEmailValidator } from 'src/app/core/utils/utilities';
import { IForgotPassword } from 'src/app/services/AuthService/auth.model';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { SharedService } from 'src/app/services/SharedService/shared.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { BRAND } from 'src/app/core/constants/brand';

@Component({
  selector: 'app-email-senha',
  templateUrl: './email-senha.component.html',
  styleUrl: './email-senha.component.scss',
})
export class EmailSenhaComponent {
  readonly brand = BRAND;
  form: FormGroup = this._inicializarFormulario();
  type: string = 'password';
  activeRoute: string = '';
  title: string = 'Enviar';
  isLoading: boolean = false;
  isEmpresa: boolean = false;
  model: any = {
    email: '',
    password: '',
    remember: false,
  };

  constructor(
    @Inject(Router) private router: Router,
    @Inject(ChangeDetectorRef) private cd: ChangeDetectorRef,
    @Inject(NgZone) private ngZone: NgZone,
    private authService: AuthService,
    private fb: FormBuilder,
    private sharedService: SharedService,
    public swalAlert: SwalAlertService
  ) {}

  ngOnInit() {
    this.isEmpresa = this.sharedService.getIsEmpresa();
  }

  onSubmit() {
    const email = this.form.get('TX_MAIL_EPSA')?.value;

    this.postarDados();
  }

  postarDados() {
    const payload = this.createPayload();
    this.isLoading = true;
    this.authService.forgotPassword(payload).subscribe(
      (response) => {
        this.swalAlert.showAlert(
          'Sucesso!',
          'Um e-mail com o link de redefinição foi enviado para o seu e-mail.',
          'success',
          true,
          false,
          undefined,
          () => {
            this.isLoading = false;
            this.ngZone.run(() => {
              this.router.navigate(['login']);
            });
          }
        );
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  createPayload(): IForgotPassword {
    return {
      AddressTo: this.form.controls['TX_MAIL_EPSA'].value,
      TipoAcessoEnum: 3,
    };
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      TX_MAIL_EPSA: ['', [Validators.required, trimEmailValidator]],
    });
    return form;
  }

  public onBack() {
    this.router.navigate(['login']);
  }
}
